export default __webpack_public_path__ + "static/media/Genetic-Counselling-and-Testing.6ce954a3.jpg";